import { combineReducers } from 'redux';

import projects from 'src/app/projects/state/projectsReducer';
import surveys from 'src/app/surveys/state/surveyReducer';
import habitatInsights from 'src/app/habitat-insights/state/habitatInsightsReducer';
import customers from 'src/app/customers/state/customersSlice';
import dashboard from 'src/app/dashboard/state/dashboardReducer';
import speciesMap from 'src/app/maps/views/species-map/state/speciesMapSlice';
import habitatMap from 'src/app/maps/views/habitat-map/state/habitatMapSlice';
import tables from 'src/app/tables/state/tablesReducer';
import ecologyHub from 'src/app/ecology-hub/state/ecologyHubReducer';
import admin from 'src/app/admin/state/adminReducer';
import global from 'src/global/state/globalReducer';
import routes from 'src/routes/state/routesSlice';
import portfolio from 'src/app/portfolio/state/portfolioReducer';
import graphApiSlice from 'src/shared/state/api-slices/graphApiSlice';
import engineApiSlice from 'src/shared/state/api-slices/engineApiSlice';
import riskMaterialityCmsSlice from 'src/shared/state/api-slices/riskMaterialityCmsSlice';

const createRootReducer = () =>
    combineReducers({
        projects,
        surveys,
        habitatInsights,
        customers,
        dashboard,
        speciesMap,
        tables,
        ecologyHub,
        admin,
        global,
        habitatMap,
        portfolio,
        routes,
        [graphApiSlice.reducerPath]: graphApiSlice.reducer,
        [engineApiSlice.reducerPath]: engineApiSlice.reducer,
        [riskMaterialityCmsSlice.reducerPath]: riskMaterialityCmsSlice.reducer,
    });

export default createRootReducer;
